// extracted by mini-css-extract-plugin
module.exports = {"content":"content--1sXmIbh8","gradient":"gradient--2fKCtt_4","title":"title--25iC7e5H","description":"description--2QVRd_TW","container_content":"container_content--Q5icRjCe"};